module.exports = __webpack_public_path__ + "img/ruby.a28d05b9.png";